import { Box, Button, ButtonProps } from "@chakra-ui/react";
import { dataAttr } from "@chakra-ui/utils";
import React, { useEffect, useRef } from "react";

export const Listbox: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Box
    position="absolute"
    top={0}
    left={0}
    right={0}
    bottom={0}
    overflowY="auto"
    display="flex"
  >
    <Box
      marginTop="auto"
      marginBottom="auto"
      p={2}
      alignItems="center"
      justifyContent="center"
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      gap={2}
    >
      {children}
    </Box>
  </Box>
);

export const ListboxItem: React.FC<
  React.PropsWithChildren<
    {
      isSelected: boolean;
      isCurrent?: boolean;
      onClick: () => void;
    } & ButtonProps
  >
> = ({ isSelected, isCurrent, children, ...props }) => {
  const ref = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isSelected && ref.current) {
      ref.current.scrollIntoView({
        inline: "center",
        block: "center",
        behavior: "auto",
      });
    }
  }, [isSelected]);

  return (
    <Button
      ref={ref}
      variant="ghost"
      aria-selected={isSelected}
      data-current={dataAttr(isCurrent)}
      fontWeight="normal"
      flexBasis="100%"
      _hover={{
        fontWeight: 600,
        bg: "primary.50",
      }}
      _selected={{
        color: "white",
        bg: "primary.500",
        _hover: {
          bg: "primary.500",
        },
      }}
      _active={{
        bg: "primary.100",
      }}
      sx={{
        "&[data-current]:not([aria-selected=true]):not(:active)": {
          bg: "gray.100",
        },
      }}
      {...props}
    >
      {children}
    </Button>
  );
};
